import type { ApiRoute, NoBody, NoQueryParams } from "../api"
import type { InventoryInformationView } from "./InventoryInformationView"

export interface GetInventoryInformationViewPathParams {
	inventoryId: string
}

export const getInventoryInformationViewRoute: ApiRoute<
	GetInventoryInformationViewPathParams,
	NoQueryParams,
	NoBody,
	InventoryInformationView
> = {
	buildUrl: (params) => `/vehicles/${params.inventoryId}/inventory-information`,
	method: "get",
	path: "/vehicles/:inventoryId/inventory-information",
}
